// import getTarget from 'javascripts/utils/get-target';
// import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { MEDIA_QUERIES } from 'javascripts/constants';
import HeaderToggleButton from './HeaderToggleButton';
import HeaderMinistryFlyout from './HeaderMinistryFlyout';
import NavigationMain from './HeaderNavigationMain';
import { click, hover } from '../../../javascripts/utils/hide-show';

// header flyout component store
let headerMinistryFlyoutComponentStore = [];

let NavigationMainComponentStore = [];

// Event registry
let eventRegistry = [];

// Toggle button for main menu and ministry flyout
let headerToggleButton = null;

function onMediaQueryChange(mq) {
  const isDesktop = mq.matches;

  // Kill all event handlers on switch
  eventRegistry.forEach(e => e());
  eventRegistry = [];

  // Deinit on desktop
  if (isDesktop && headerToggleButton) {
    headerToggleButton.deconstructor();
    headerToggleButton = null;
  // Init on mobile
  } else if (!isDesktop && !headerToggleButton) {
    const $toggleButton = document.querySelector('#header-toggle');
    if ($toggleButton) {
      headerToggleButton = new HeaderToggleButton($toggleButton);
    }
  }

  // Init the Ministry-Menu
  const headerMinistryFlyoutToggle = document.getElementById('header-ministry-flyout-toggle');

  if (headerMinistryFlyoutToggle) {
    headerMinistryFlyoutComponentStore
      .forEach(store => store.deconstructor && store.deconstructor());
    headerMinistryFlyoutComponentStore = [];

    headerMinistryFlyoutComponentStore
      .push(new HeaderMinistryFlyout(headerMinistryFlyoutToggle, mq));
  }

  // Init dropdown navigation
  if (isDesktop) {
    document.querySelectorAll('.header__navigation-item--main[aria-haspopup="true"]').forEach(($link) => {
      $link.addEventListener('mousedown', e => e.preventDefault());
      eventRegistry.push(hover($link, 200));
    });
  // Deinit on mobile
  } else {
    document.querySelectorAll('.navigation__link[aria-haspopup="true"]').forEach(($link) => {
      eventRegistry.push(click($link, false));
    });
  }

  // Init the Main-Menu
  const headerNavigationMain = document.querySelector('.header__navigation--main');

  if (headerNavigationMain) {
    NavigationMainComponentStore
      .forEach(store => store.deconstructor && store.deconstructor());
    NavigationMainComponentStore = [];

    NavigationMainComponentStore
      .push(new NavigationMain(headerNavigationMain, mq));
  }
}

// Init media query listener
const mql = window.matchMedia(MEDIA_QUERIES.headernav);
mql.addListener(onMediaQueryChange);
onMediaQueryChange(mql);
